import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdated, children }) {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="legal-page">
      <Link to="/" className="inline-flex items-center text-sm text-slate-600 hover:text-slate-900 mb-6">
        <ArrowLeft className="w-4 h-4 mr-1" /> {t("nav.home")}
      </Link>
      <div className="mec-overline mb-3">{t("legal.document_label")}</div>
      <h1 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mb-2">{title}</h1>
      {lastUpdated && (
        <p className="text-sm text-slate-500 mb-8">{t("legal.last_updated")}: {lastUpdated}</p>
      )}
      <div className="mec-card p-8 prose-mec text-slate-700 leading-relaxed space-y-4">
        {children}
      </div>
    </div>
  );
}
